//module dedicado a los items de navegacion de menu

import Vue from "vue";
import Vuex from 'vuex';

Vue.use(Vuex)

export default ({
    namespaced: true,
    state: {
        items: [],

        menuEspecial: [
            { title: 'Mi legajo', icon: 'mdi-account-outline', route: '/dashboard' },
            //  { title: 'Información de contacto', icon: 'mdi-email-outline', route: '/listarContactos' },
            { title: 'Opción de nivel', icon: 'mdi-account-star-outline', route: '/opcionDeNivel', accion: 'dialogoOpcionNivel' },
            { title: 'Turnos', icon: 'mdi-calendar-clock-outline', route: '/Turnos' },
            {
                title: 'Aportes', icon: 'mdi-list-box-outline', children: [
                    { title: 'Realizar pagos', route: '/boletas' },
                    { title: 'Consultar pagos', route: '/consultaPagos' },
                    { title: 'Pericias', route: '/pericias' },
                    { title: 'Detalle de aportes', route: '/DetalleDeAportes' },
                    { title: 'Planes de pago', route: '/PlanesDePago' },
                ]
            },
            /*   { title: 'Trámites', icon: 'mdi-file-document-multiple-outline', route: '/Tramites' }, */
            {
                title: 'Trámites', icon: 'mdi-file-document-multiple-outline', children: [
                    { title: 'Trámites realizados', route: '/Tramites' },
                    { title: 'Subsidios', route: '/subsidios' },

                    /*                     {
                                            title: 'Solicitar trámite', icon: 'mdi-plus', group: false, children: [
                                                { title: 'Prestamos', route: '/Prestamos' },
                                                { title: 'Subsidios', route: '/Subsidios' },
                                            ]
                                        }, */
                ], group: false
            },

            // { title: 'Credencial virtual', icon: 'mdi-card-account-details-outline', action: this.handleCredencialVirtual },
            /*             {
                            title: 'Credenciales', icon: 'mdi-card-account-details-outline', children: [
                                { title: 'Credencial de Afiliado', action: 'credencialAfiliado' },
                                { title: 'Constancia convenios', action: 'constanciaConvenios' },
            
                            ]
                        }, */
            /*   { title: 'Comunicaciones', icon: 'mdi-newspaper-variant-outline', route: '/comunicaciones' }, */
            /* { title: 'Webmail', icon: 'mdi-mailbox', action: this.goWebMail }, */
            { title: 'Contacto', icon: 'mdi-message-text-outline', route: '/mediosDeContacto' },
        ],
        menuActivo: [
            { title: 'Mi legajo', icon: 'mdi-account-outline', route: '/dashboard' },
            //  { title: 'Información de contacto', icon: 'mdi-email-outline', route: '/listarContactos' },
            // No habilidado por el momento 
            { title: 'Opción de nivel', icon: 'mdi-account-star-outline', route: '/opcionDeNivel', accion: 'dialogoOpcionNivel' },
            { title: 'Turnos', icon: 'mdi-calendar-clock-outline', route: '/Turnos' },
            {
                title: 'Aportes', icon: 'mdi-list-box-outline', children: [
                    { title: 'Realizar pagos', route: '/boletas' },
                    { title: 'Consultar pagos', route: '/consultaPagos' },
                    { title: 'Pericias', route: '/pericias' },
                    { title: 'Detalle de aportes', route: '/DetalleDeAportes' },
                    { title: 'Planes de pago', route: '/PlanesDePago' },
                    /*  { title: 'Medios de pago', route: '/MediosDePago2' }, */
                ]
            },
            /*   { title: 'Trámites', icon: 'mdi-file-document-multiple-outline', route: '/Tramites' }, */
            {
                title: 'Trámites', icon: 'mdi-file-document-multiple-outline', children: [
                    { title: 'Trámites realizados', route: '/Tramites' },

                    { title: 'Subsidios', route: '/subsidios' },
                    /*                     {
                                            title: 'Solicitar trámite', icon: 'mdi-plus', group: false, children: [
                                                { title: 'Prestamos', route: '/Prestamos' },
                                                { title: 'Subsidios', route: '/Subsidios' },
                                                  { title: 'Adhesión a débito automático', route: '/MediosDePago' },
                                            ]
                                        }, */
                ], group: false
            },

            // { title: 'Credencial virtual', icon: 'mdi-card-account-details-outline', action: this.handleCredencialVirtual },
            {
                title: 'Credenciales', icon: 'mdi-card-account-details-outline', children: [
                    { title: 'Credencial de Afiliado', action: 'credencialAfiliado' },
                    { title: 'Constancia convenios', action: 'constanciaConvenios' },

                ]
            },
            { title: 'Comunicaciones', icon: 'mdi-newspaper-variant-outline', route: '/comunicaciones' },
            /* { title: 'Webmail', icon: 'mdi-mailbox', action: this.goWebMail }, */
            { title: 'Contacto', icon: 'mdi-message-text-outline', route: '/mediosDeContacto' },
        ],
        menuActivoPreProd: [
            { title: 'Mi legajo', icon: 'mdi-account-outline', route: '/dashboard' },
            //  { title: 'Información de contacto', icon: 'mdi-email-outline', route: '/listarContactos' },
            { title: 'Opción de nivel', icon: 'mdi-account-star-outline', route: '/opcionDeNivel', accion: 'dialogoOpcionNivel' },
            { title: 'Turnos', icon: 'mdi-calendar-clock-outline', route: '/Turnos' },
            {
                title: 'Aportes', icon: 'mdi-list-box-outline', children: [
                    { title: 'Realizar pagos', route: '/boletas' },
                    { title: 'Consultar pagos', route: '/consultaPagos' },
                    { title: 'Pericias', route: '/pericias' },
                    { title: 'Detalle de aportes', route: '/DetalleDeAportes' },
                    /*    { title: 'Planes de pago', route: '/PlanesDePago' }, */
                    /*                     { title: 'Planes de pago', route: '/MediosDePago' },
                                        { title: 'Medios de pago', route: '/MediosDePago2' }, */
                ]
            },
            /*   { title: 'Trámites', icon: 'mdi-file-document-multiple-outline', route: '/Tramites' }, */
            {
                title: 'Trámites', icon: 'mdi-file-document-multiple-outline', children: [
                    { title: 'Trámites realizados', route: '/Tramites' },

                    { title: 'Subsidios', route: '/subsidios' },
                    /*                     {
                                            title: 'Solicitar trámite', icon: 'mdi-plus', group: false, children: [
                                                { title: 'Prestamos', route: '/Prestamos' },
                                                { title: 'Subsidios', route: '/Subsidios' },
                                                  { title: 'Adhesión a débito automático', route: '/MediosDePago' },
                                            ]
                                        }, */
                ], group: false
            },

            // { title: 'Credencial virtual', icon: 'mdi-card-account-details-outline', action: this.handleCredencialVirtual },
            {
                title: 'Credenciales', icon: 'mdi-card-account-details-outline', children: [
                    { title: 'Credencial de Afiliado', action: 'credencialAfiliado' },
                    { title: 'Constancia convenios', action: 'constanciaConvenios' },

                ]
            },
            { title: 'Comunicaciones', icon: 'mdi-newspaper-variant-outline', route: '/comunicaciones' },
            /* { title: 'Webmail', icon: 'mdi-mailbox', action: this.goWebMail }, */
            { title: 'Contacto', icon: 'mdi-message-text-outline', route: '/mediosDeContacto' },
        ],
        menuJubilado: [
            { title: 'Mi legajo', icon: 'mdi-account-outline', route: '/dashboard' },
            { title: 'Turnos', icon: 'mdi-calendar-clock-outline', route: '/Turnos' },
            { title: 'Recibo de haberes', icon: 'mdi-list-box-outline', route: '/Haberes' },
            { title: 'Pericias', icon: 'mdi-scale-balance', route: '/pericias' },
            {
                title: 'Prestamos', icon: 'mdi-cash-multiple', children: [
                    { title: 'Detalle de prestamos', route: '/DetalleDeAportes' },
                    { title: 'Realizar pagos', route: '/boletas' },
                    { title: 'Consultar pagos', route: '/consultaPagos' },
                ]
            },
            {
                title: 'Trámites', icon: 'mdi-file-document-multiple-outline', children: [
                    { title: 'Trámites realizados', route: '/Tramites' },

                    { title: 'Subsidios', route: '/subsidios' },
                    /*                     {
                                            title: 'Solicitar trámite', icon: 'mdi-plus', group: false, children: [
                                                { title: 'Prestamos', route: '/Prestamos' },
                                                { title: 'Subsidios', route: '/Subsidios' },
                                                  { title: 'Adhesión a débito automático', route: '/MediosDePago' },
                                            ]
                                        }, */
                ], group: false
            },
            { title: 'Credencial', icon: 'mdi-card-account-details-outline', action: 'credencialJubilado' },
            { title: 'Comunicaciones', icon: 'mdi-newspaper-variant-outline', route: '/comunicaciones' },
            { title: 'Contacto', icon: 'mdi-message-text-outline', route: '/mediosDeContacto' },
        ],
    },
    getters: {
        items(state, getters, rootState, rootGetters) {
            const estadoNivelPedido = rootState.opcionNivel?.opcionNivelAfiliado?.estadoNivelPedido
            const userNivelValidez = rootState.auth?.user?.nivel_validez
            const userEsJubilado = rootState.auth?.user?.esjubilado
            const esesb = rootState.auth?.user?.esesb
            // Una sola fuente de verdad para el corte: el mismo getter que consulta
            // el guard del router. El menu no vuelve a leer process.env.
            const subsidiosHabilitados = rootGetters['subsidios/subsidiosHabilitados']
            const opcionNivelHabilitado = rootGetters['opcionNivel/opcionNivelHabilitado']
            return state.items
                .filter(item => {
                    // Ocultar "Opción de nivel" si nivel_validez es 'P'
                    if (item.title === 'Opción de nivel' && userNivelValidez === 'P' && userEsJubilado) {
                        return false
                    }
                    if (item.title === 'Opción de nivel' && !opcionNivelHabilitado) {
                        return false
                    }
                    if (item.title === 'Subsidios' && !subsidiosHabilitados) {
                        return false
                    }
                    return true
                })
                .map(item => {
                    if (item.title == 'Opción de nivel') {
                        // El badge de novedad se destaca salvo en dos casos: los esesb
                        // no tramitan nivel por el portal, y un tramite ya APROBADO
                        // ('A') no es una novedad pendiente.
                        // Estuvo clavado en false mientras el feature estaba apagado
                        // a mano (commit 964b07a). Ahora el corte lo hace el flag en
                        // el filter de arriba: si llega hasta aca, el feature esta
                        // prendido y el destacado vuelve a depender del tramite.
                        const debeDestacar = esesb == 1 ? false : estadoNivelPedido !== 'A'
                        return { ...item, destacado: debeDestacar }
                    }
                    // En los cuatro menus el item de Subsidios cuelga de 'Trámites',
                    // asi que el corte real pasa por los children: el filter de arriba
                    // solo mira la raiz y nunca lo alcanzaria.
                    if (!subsidiosHabilitados && item.children) {
                        return { ...item, children: item.children.filter(hijo => hijo.title !== 'Subsidios') }
                    }
                    return item
                })
        }
    },

    mutations:
    {
        setItems(state, payload) {
            // payload: { esactivo: boolean, esjubilado: boolean, esesb: boolean }
            if (payload.esactivo) {
                // si es activo, cargo el menu normal
                state.items = state.menuActivo;
                // si es activo y ademas el nroafi es 19, 18, 1548 mostrar items menuActivoPreProd
                /* if (['19', '18', '1548'].includes(sessionStorage.getItem('nroafi'))) {
                    state.items = state.menuActivoPreProd;
                } */
            } else if (payload.esjubilado) {
                state.items = state.menuJubilado;
            } else if (payload.esesb) {
                state.items = state.menuEspecial;
            } else {
                state.items = [];
            }
        }
    },
    actions:
    {
        fetchItems({ commit }, payload) {
            commit('setItems', payload);
        }
    },
})